import { useState } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import Loader from "../Loader.js";
import { AnalysisAPI } from "../../api/index.js";
import { useMutation } from "@tanstack/react-query";
import LoggingAPI from "../../api/logging/index.js";
import { usePermissions } from "../../hooks/usePermissions";
import { DefaultTraceAccountForm } from "../Forms";

export const EditTraceAccountModal = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultFormData,
  ...props
}) => {
  const { currentUser } = usePermissions();
  const [submitting, setSubmitting] = useState(false);

  const update = useMutation({
    mutationFn: AnalysisAPI.Accounts.update,
    onMutate: () => setSubmitting(true),
    onSuccess: (_, variables) => {
      LoggingAPI.createLog({
        case_id: defaultFormData.case_id,
        user_id: currentUser.user_id,
        message: `Updated trace account.`,
        event: "trace_account:update",
        object_type: "trace_account",
        object_uuid: defaultFormData.uuid,
      });
      onSubmit?.(defaultFormData, variables);
      setSubmitting(false);
    },
  });

  return (
    <Modal
      open={show}
      onClose={onClose}
      style={{ width: 550 }}
      FocusProps={{ initialFocus: -1 }}
    >
      <Modal.Title style={{ marginBottom: 10 }}>Edit Trace Account</Modal.Title>
      {!submitting && (
        <DefaultTraceAccountForm
          onSubmit={(data, diff) => update.mutate({ uuid: data.uuid, ...diff })}
          onCancel={onCancel}
          defaultFormData={defaultFormData}
          {...props}
        />
      )}
      {submitting && <Loader />}
    </Modal>
  );
};
